export default __webpack_public_path__ + "static/media/ar_2017_image.ea6cab48.png";